import { render, staticRenderFns } from "./TakeOverToolbar.vue?vue&type=template&id=47a4cbb6&scoped=true&"
import script from "./TakeOverToolbar.vue?vue&type=script&lang=js&"
export * from "./TakeOverToolbar.vue?vue&type=script&lang=js&"
import style0 from "./TakeOverToolbar.vue?vue&type=style&index=0&id=47a4cbb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4cbb6",
  null
  
)

export default component.exports